import { TransformedSuperGridColDef } from '@aleph/shared-components';
import { startCase } from 'lodash';
import { EditableCallbackParams, ICellRendererParams } from 'ag-grid-community';
import { SpotifyLevel } from 'wb-spotify/app/routes/superGrid/utils';
import { SPOTIFY_DRAFT_STATUSES } from 'wb-spotify/app/routes/superGrid/cellRenderers/utils/status';

export const editableOnThisLevel = (params: EditableCallbackParams | ICellRendererParams): boolean => {
	const colDef = params.colDef as TransformedSuperGridColDef<SpotifyLevel>;

	// If entity is in draft we want to allow editing.
	if (SPOTIFY_DRAFT_STATUSES.includes(params?.data?.status) && !params?.data?.isExistingCreate) {
		return true;
	}

	if (
		// When entity is not yet synced to spotify, the externalId is null. In this case we don't want to allow editing.
		!params?.data?.externalId
        && !params?.data?.hasErrors
        && params.data?.id
	) {
		return false;
	}

	return colDef?.level === params.data?.level
		&& !params?.data?.isCreate && !params?.data?.isExistingCreate
		&& (!params.context?.isInCreation || !params.data?.id);
};

export const editableOnLevel = (level: SpotifyLevel) => (params: EditableCallbackParams): boolean => (
	level === params.data?.level
		&& !params?.data?.isCreate && !params?.data?.isExistingCreate
		&& (!params.context?.isInCreation || !params.data?.id)
);

export const getOptionsFromEnum = (
	options: Record<string, string>,
	capitalize = true,
) => Object.keys(options).filter(option => option !== 'Unknown').map((option: string) => ({
	value: options?.[option] as string,
	label: capitalize ? startCase(option) : option,
}));

export function processParent(parent: any) {
	if (!parent) {
		return undefined;
	}

	return {
		...parent,
		isExistingCreate: true,
		parent:           processParent(parent.parent),
	};
}
